import template from './swag-cms-extensions-block-config-rule.html.twig';
import './swag-cms-extensions-block-config-rule.scss';

export default {
    template,

    inject: [
        'repositoryFactory',
        'acl',
    ],

    props: {
        block: {
            type: Object,
            required: true,
        },
    },

    computed: {
        blockRuleRepository() {
            return this.repositoryFactory.create('swag_cms_extensions_block_rule');
        },

        blockRule() {
             return this.block.extensions.swagCmsExtensionsBlockRule;
        },
    },

    watch: {
        block: {
            handler() {
                if (typeof this.block.extensions?.swagCmsExtensionsBlockRule === 'object') {
                    return
                }
                this.createDefaultBlockRule();
            },
            immediate: true,
        },
    },

    methods: {
        createDefaultBlockRule() {
            const defaultRule = this.blockRuleRepository.create(Shopware.Context.api);
            defaultRule.visibilityRuleId = null;
            defaultRule.inverted = false;

            this.block.extensions.swagCmsExtensionsBlockRule = defaultRule;
        },

        onSaveRule(ruleId) {
            this.block.extensions.swagCmsExtensionsBlockRule.visibilityRuleId = ruleId;
        },
    },
}
